import React from 'react';
import { VaultKeTheme } from '../../utils/theme';

const Community: React.FC = () => {
  const styles: { [key: string]: React.CSSProperties } = {
    page: {
      minHeight: '100vh',
      backgroundColor: VaultKeTheme.colors.background,
      color: VaultKeTheme.colors.text,
    },
    main: {
      paddingTop: '80px',
      paddingBottom: VaultKeTheme.spacing.xxl,
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: `0 ${VaultKeTheme.spacing.xl}`,
    },
    header: {
      textAlign: 'center',
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    title: {
      ...VaultKeTheme.typography.h1,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    subtitle: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      maxWidth: '600px',
      margin: '0 auto',
    },
    stats: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: VaultKeTheme.spacing.xl,
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    stat: {
      textAlign: 'center',
      ...VaultKeTheme.components.card,
    },
    statNumber: {
      ...VaultKeTheme.typography.h2,
      color: VaultKeTheme.colors.primary,
      marginBottom: VaultKeTheme.spacing.sm,
    },
    statLabel: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
    },
    features: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: VaultKeTheme.spacing.xl,
      marginBottom: VaultKeTheme.spacing.xxl,
    },
    feature: {
      ...VaultKeTheme.components.card,
      textAlign: 'center',
    },
    featureIcon: {
      fontSize: '3rem',
      marginBottom: VaultKeTheme.spacing.md,
    },
    featureTitle: {
      ...VaultKeTheme.typography.h4,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.sm,
    },
    featureDesc: {
      ...VaultKeTheme.typography.body2,
      color: VaultKeTheme.colors.textSecondary,
    },
    cta: {
      textAlign: 'center',
      ...VaultKeTheme.components.card,
    },
    ctaTitle: {
      ...VaultKeTheme.typography.h3,
      color: VaultKeTheme.colors.text,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    ctaText: {
      ...VaultKeTheme.typography.body1,
      color: VaultKeTheme.colors.textSecondary,
      marginBottom: VaultKeTheme.spacing.lg,
    },
    ctaButton: {
      ...VaultKeTheme.components.button.primary,
    },
  };

  const features = [
    {
      icon: '💬',
      title: 'Discussion Forums',
      description: 'Connect with other chama leaders, share experiences, and learn from the community.',
    },
    {
      icon: '📚',
      title: 'Knowledge Base',
      description: 'Access guides, best practices, and resources to improve your chama management.',
    },
    {
      icon: '🎓',
      title: 'Webinars & Training',
      description: 'Join live sessions and workshops on financial management and chama governance.',
    },
    {
      icon: '🤝',
      title: 'Mentorship Program',
      description: 'Get guidance from experienced chama leaders and financial experts.',
    },
    {
      icon: '📊',
      title: 'Success Stories',
      description: 'Read about successful chamas and learn from their journeys and strategies.',
    },
    {
      icon: '🎯',
      title: 'Events & Meetups',
      description: 'Attend local and virtual events to network with other chama communities.',
    },
  ];

  return (
    <div style={styles.page}>
      <main style={styles.main}>
        <div style={styles.container}>
          <div style={styles.header}>
            <h1 style={styles.title}>VaultKe Community</h1>
            <p style={styles.subtitle}>
              Join a thriving community of chama leaders, financial experts, and innovators
              working together to build stronger communities through better finance.
            </p>
          </div>

          <div style={styles.stats}>
            <div style={styles.stat}>
              <div style={styles.statNumber}>10K+</div>
              <div style={styles.statLabel}>Community Members</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>500+</div>
              <div style={styles.statLabel}>Active Discussions</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>50+</div>
              <div style={styles.statLabel}>Countries</div>
            </div>
            <div style={styles.stat}>
              <div style={styles.statNumber}>24/7</div>
              <div style={styles.statLabel}>Support Available</div>
            </div>
          </div>

          <div style={styles.features}>
            {features.map((feature, index) => (
              <div key={index} style={styles.feature}>
                <div style={styles.featureIcon}>{feature.icon}</div>
                <h3 style={styles.featureTitle}>{feature.title}</h3>
                <p style={styles.featureDesc}>{feature.description}</p>
              </div>
            ))}
          </div>

          <div style={styles.cta}>
            <h3 style={styles.ctaTitle}>Ready to Join the Community?</h3>
            <p style={styles.ctaText}>
              Connect with like-minded individuals, share your experiences, and learn from others
              in our vibrant community of chama leaders and financial innovators.
            </p>
            <button style={styles.ctaButton}>Join Community</button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Community;